export enum UserEntityProfileType {
    USER = 0,
    ENS_MANAGER = 1,
    SERVICE_MANAGER = 2,
    SIGNER = 3,
    SUPPORT = 4,
    ADMIN = 6
}

export const USER_ENTITY_PROFILE_TYPE = [
    { id: UserEntityProfileType.USER, name: "Bàsic" },
    { id: UserEntityProfileType.ENS_MANAGER, name: "Gestor de l'entitat" },
    { id: UserEntityProfileType.SERVICE_MANAGER, name: "Prestador" },
    { id: UserEntityProfileType.SIGNER, name: "Signador" },
    { id: UserEntityProfileType.SUPPORT, name: "Suport CAU" }
]

export const USER_ENTITY_PROFILE_TYPE_MAP = new Map(
    USER_ENTITY_PROFILE_TYPE.map(item => [item.id, item.name])
)
